import React, { useContext, useRef } from "react";
import Button from "@amzn/meridian/button";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {
  getShiftPlanSettingsS3DownloadUrl,
  getShiftPlanSettingsS3UploadUrl,
} from "./SsdSettingsNetworkAPI";
import { SsdSettingsContext } from "./SsdSettingsContext";
import { chainWalk, getFormattedTime } from "../../../util/Util";
import Text from "@amzn/meridian/text";
import { FileTransferUtil } from "../FileTransferUtil";

const SsdAdminSettings = (props) => {
  const { viewModel, dispatch } = useContext(SsdSettingsContext);
  const fileInputRef = useRef(null);
  const isUserAuthorisedForSettingsEdit = true;

  const lastUpdatedBy = chainWalk(
    () => viewModel.settingsData.adminSettings.lastUpdatedBy,
    null,
  );
  const lastUpdatedAt = chainWalk(
    () => viewModel.settingsData.adminSettings.lastUpdatedAt,
    null,
  );

  const { isValidFile, alertMessage, error, handleDownload, handleFileChange } =
    FileTransferUtil({
      getDownloadUrl: getShiftPlanSettingsS3DownloadUrl,
      getUploadUrl: getShiftPlanSettingsS3UploadUrl,
      fileName: "AdminSettings",
      onUploadSuccess: (updatedData) => {
        dispatch({
          type: "UPDATE_ADMIN_SETTINGS",
          data: {
            adminSettings: updatedData,
          },
        });
      },
      errorMessages: {
        fileNotExist:
          "Admin Settings file does not exist. Please upload a valid one.",
      },
    });

  let lastUpdatedAtDisplayText = "";
  if (lastUpdatedAt != null) {
    lastUpdatedAtDisplayText = `Last Updated: ${getFormattedTime(
      new Date(lastUpdatedAt * 1000),
      "en-US",
    )}`;
    if (lastUpdatedBy != null) {
      lastUpdatedAtDisplayText =
        lastUpdatedAtDisplayText + ` (${lastUpdatedBy}@)`;
    }
  }

  return (
    <div>
      <Box type="fill" spacingInset="400">
        <Row alignmentVertical={"center"} widths={"fill"}>
          <Row alignmentHorizontal={"left"}>
            <Text type="b200">{lastUpdatedAtDisplayText}</Text>
          </Row>
          <Row alignmentHorizontal={"right"}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept=".json"
              style={{ display: "none" }}
            />
            <Button
              type="tertiary"
              size={"small"}
              onClick={() => fileInputRef.current.click()}
              disabled={!isUserAuthorisedForSettingsEdit}
            >
              Upload Admin Settings
            </Button>
            <Button
              type="primary"
              size={"small"}
              onClick={handleDownload}
              disabled={!isUserAuthorisedForSettingsEdit}
            >
              Download Admin Settings
            </Button>
          </Row>
        </Row>
      </Box>
      <div />
      {alertMessage && (
        <Alert
          type={isValidFile === true && error === false ? "success" : "error"}
          size="medium"
        >
          {alertMessage}
        </Alert>
      )}
    </div>
  );
};

export default SsdAdminSettings;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/SsdAdminSettings.js